import { render, staticRenderFns } from "./ClassifyProduct.vue?vue&type=template&id=390e6e2b&scoped=true"
import script from "./ClassifyProduct.vue?vue&type=script&lang=js"
export * from "./ClassifyProduct.vue?vue&type=script&lang=js"
import style0 from "./ClassifyProduct.vue?vue&type=style&index=0&id=390e6e2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390e6e2b",
  null
  
)

export default component.exports